// Constant
import { Routes } from "constants/global";

export const SideNavConstants = {
	HEAD_TEXT: "Fabian Ng",
	SUB_TEXT: "00200456",
	TENANT_CODE: "Tenant Code:",
	ADMIN_ID: "Admin ID:",
	INPUT_PLACEHOLDER: "e.g. Beauty Circle",
	LOGOUT_TITLE: "You have been logged out due to inactivity",
	LOGOUT_SUBTITLE: "Please log in again to access the Portal",
	LOGOUT_OKAY_BTN: "Got it!",
	ADMIN_MENU: [
		{ icon: "userAccount", label: "Account Management", route: Routes.ACCOUNT_MANAGEMENT, code: "CREATE_EDIT_TENANT_ACCOUNT", id: 6, protected: true },
		{ icon: "verification", label: "Declaration verification", route: Routes.DECLARATION_VERIFICATION, code: "REIMB_DECLRATION_VERIFY", id: 3, protected: true },
		{ icon: "chartWithTick", label: "Declaration approval", route: Routes.DECLARATION_APPROVAL, code: "REIMB_DECLRATION_APPROVE", id: 13, protected: true },
		// { icon: "receipt", label: "Receipt management", route: Routes.RECEIPT_MANAGEMENT, code: "RECEIPT_MANAGEMENT", id: 14, protected: true },
		{ icon: "report", label: "Reports (Admin)", route: Routes.REPORTS_ADMIN, code: "REIM_REPORTS_ADMIN", id: 5, protected: true },
		{ icon: "divider", label: "divider", route: "", code: "divider", id: 16, showDivider: true },
		{ icon: "retroClaim", label: "Retrospective claim", route: Routes.RETRO_CLAIM, code: "RETROSPECTIVE_CLAIM", id: 21, protected: true },
		{ icon: "ticket", label: "Offer Redemption", route: Routes.OFFER_REDEMPTION, code: "OFFER_REDEMPTION", id: 52, protected: true },
		{
			icon: "ticket",
			label: "Offer Issuance",
			route: [Routes.OFFER_ISSUANCE_APPROVE, Routes.OFFER_ISSUANCE_CREATE, Routes.OFFER_ISSUANCE],
			code: ["OFFER_ISSUANCE_APPROVE", "OFFER_ISSUANCE_CREATE", "OFFER_ISSUANCE"],
			id: [58, 57, 51],
			protected: true
		},
		{ icon: "offer", label: "Offer Update", route: Routes.OFFER_UPDATE, code: "OFFER_ISSUANCE", id: 53, protected: true },
		{ icon: "accountCreation", label: "Non-Member Account", route: Routes.NONMEMBER_ACCOUNT, code: "NONMEMBER_ACCOUNT", id: 54, protected: true },
		{ icon: "role", label: "Role Management", route: Routes.ROLE_MANAGEMENT, code: "ROLE_MANAGEMENT", id: 9, protected: true },
		{ icon: "delink", label: "Delink CapitaStar", route: Routes.DELINK, code: "DELINK_CAPITASTAR", id: 28, protected: true },
		{ icon: "vehicleDelink", label: "Delink Vehicle IU", route: Routes.VEHICLE_DELINK, code: "DELINK_VEHICLE_IU", id: 25, protected: true },
		{ icon: "delink", label: "Delink KrisFlyer", route: Routes.KRISFLYER_DELINK, code: "DELINK_KRISFLYER", id: 56, protected: true },
		{ icon: "report", label: "Ad-Hoc Reports (Admin)", route: Routes.REPORT_ADHOC, code: "ADHOC_REPORTS_ADMIN", id: 27, protected: true },
		{ icon: "merge", label: "Merge CR Accounts", route: Routes.MERGE_CR_ACCOUNTS, code: "MERGE_CR_ACCOUNTS", id: 31, protected: true },
		{ icon: "crPointsExpirySummary", label: "Member Points Expiry", route: Routes.CR_POINTS_EXPIRY_SUMMARY, code: "CR_POINTS_EXPIRY_SUMMARY", id: 48, protected: true },
		{
			icon: "CRMembershipStatus",
			label: "Membership Status",
			route: Routes.CR_MEMBERSHIP_STATUS,
			code: "CR_MEMBERSHIP_STATUS",
			id: 50,
			protected: true
		},
		{ icon: "voidCRTransaction", label: "Void CR Transaction", route: Routes.VOID_CR_TRANSACTION, code: "VOID_CR_TRANSACTION", id: 47, protected: true },
		{
			icon: "sessionM",
			label: "SessionM",
			route: Routes.SESSIONM,
			code: "SESSION_M",
			id: 26,
			protected: true
		},
		{
			icon: "report",
			label: "Outlet Management",
			route: Routes.OUTLET_MANAGEMENT,
			code: "OUTLET_MANAGEMENT",
			id: 55,
			protected: true
		},
		{
			icon: "report",
			label: "EV Enquiry",
			route: Routes.EV_ENQUIRY_MANAGEMENT,
			code: "EV_ENQUIRY_LISTING",
			id: 56,
			protected: true
		},
		{ icon: "divider", label: "divider", route: "", code: "divider", id: 26, showDivider: true },
		{
			icon: "settings",
			label: "System Settings",
			route: Routes.SYSTEM_SETTINGS,
			code: "SETTINGS_VIEW",
			id: 57,
			protected: true
		},
		{
			icon: "report",
			label: "Onboarding and User Guide",
			route: Routes.ONBOARDING_FILES,
			code: ["TENANT_ONBOARDING_FILES", "CCC_ONBOARDING_FILES"],
			id: 60,
			protected: true
		},
		{ icon: "divider", label: "divider", route: "", code: "divider", id: 27, showDivider: true },
		{ icon: "logout", label: "Logout", route: Routes.LOGOUT, id: 999 }
	],
	TENANT_MENU: [
		{ icon: "chartWithTick", label: "Monthly Declarations", route: Routes.MONTHLY_DECLARATIONS, code: "REIM_MONTHLY_DECLARATION", id: 41, protected: true },
		{ icon: "report", label: "Reports", route: Routes.REPORTS_TENANT, code: "REIM_REPORTS_TENANT", id: 42, protected: true },
		{ icon: "divider", label: "divider", route: "", code: "divider", id: 16, showDivider: true },
		{
			icon: "report",
			label: "Onboarding and User Guide",
			route: Routes.ONBOARDING_FILES,
			code: ["TENANT_ONBOARDING_FILES", "CCC_ONBOARDING_FILES"],
			id: 60,
			protected: true
		},
		{ icon: "divider", label: "divider", route: "", code: "divider", id: 16, showDivider: true },
		{ icon: "logout", label: "Logout", route: Routes.LOGOUT, id: 999 }
	]
};
